import { render } from "./PAMMMoneyManagerList.vue?vue&type=template&id=b2bc1dfa"
import script from "./PAMMMoneyManagerList.vue?vue&type=script&lang=js"
export * from "./PAMMMoneyManagerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.7.4__webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__